import React from "react";

import { IconButton as MuiIconButton } from "@mui/material";

import { useIconButtonStyles } from "./base/styles";
import { BaseIconButtonProps } from "./base/types";

export const IconButton: React.FC<BaseIconButtonProps> = ({
  size = "default",
  icon,
  ...props
}) => {
  const { classes } = useIconButtonStyles();

  const getButtonStyles = (size: BaseIconButtonProps["size"]) => {
    let className;
    let muiSize: "small" | "medium" | "large" = "medium";

    switch (size) {
      case "tiny":
        className = classes.tiny;
        break;
      case "smallest":
        className = classes.smallest;
        break;
      case "smaller":
        className = classes.smaller;
        muiSize = "medium";
        break;
      case "small":
        muiSize = "small";
        break;
      case "default":
        muiSize = "medium";
        break;
      case "large":
        muiSize = "large";
        break;
      case "larger":
        className = classes.larger;
        muiSize = "large";
        break;
    }

    return { className, muiSize };
  };

  const { className, muiSize } = getButtonStyles(size);

  return (
    <MuiIconButton className={className} size={muiSize} {...props}>
      {icon}
    </MuiIconButton>
  );
};
